<div class="flex justify-between mx-auto px-0 items-center lg:px-4 mb-2" *ngIf="isToken && isDashboardPage">
  <div class="tab-head">All Games</div>
  <div class="search-wrap">
    <input type="text" class="search-input" placeholder="Search games..." [(ngModel)]="searchTerm" (input)="onSearch()" />
    <button class="search-btn" aria-label="Search">
      <svg viewBox="0 0 20 20" fill="currentColor" width="14" height="14">
        <path fill-rule="evenodd"
          d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
          clip-rule="evenodd" />
      </svg>
    </button>
  </div>
</div>

<!-- Skeleton placeholders while game badges/offers are still loading -->
<div *ngIf="isToken && isDashboardPage && gamesLoading"
  class="games-grid-container text-center">
  <div *ngFor="let tile of skeletonTiles" class="game-card-v2 flex flex-col justify-between w-full relative p-2.5">
    <ngx-skeleton-loader [theme]="{ height: '80px', margin: '0', borderRadius: '10px', background: 'rgba(255,255,255,0.08)' }"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{ height: '14px', width: '70%', margin: '8px auto 6px', background: 'rgba(255,255,255,0.08)' }"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{ height: '32px', margin: '0', borderRadius: '8px', background: 'rgba(255,255,255,0.08)' }"></ngx-skeleton-loader>
  </div>
</div>

<div id="games-scroll-id" *ngIf="isToken && isDashboardPage && !gamesLoading"
  class="games-grid-container text-center"
  [ngClass]="!isToken ? 'mx-0 2xl:mx-28' : ''">
  <ng-container *ngFor="let game of displayedGames; trackBy: trackByGameName">
    <ng-container *ngTemplateOutlet="gameCardTpl; context: { $implicit: game }"></ng-container>
  </ng-container>
</div>

<ng-template #gameCardTpl let-game>
    <div class="game-card-v2 group" (click)="!game.maintenance && playGame(game)">

      <!-- Status badges -->
      <span *ngIf="game?.isHot" class="gc2-badge gc2-badge-hot">
        <i class="fas fa-fire mr-1 text-[8px]"></i>
        <span class="gc2-badge-text">HOT</span>
      </span>

      <span *ngIf="game?.isNew && !game?.isHot" class="gc2-badge gc2-badge-new">
        <i class="fas fa-bolt mr-1 text-[8px]"></i>
        <span class="gc2-badge-text">NEW</span>
      </span>

      <!-- Bonus corner badge -->
      <span *ngIf="game?.bonus" class="gc2-badge-bonus">
        <span class="gc2-bonus-percent">+{{ game?.bonus }}%</span>
        <span class="gc2-bonus-label">BONUS</span>
      </span>

      <!-- Top artwork area with hover play overlay -->
      <div class="gc2-artwork">
        <div *ngIf="game.icon; else gcImgTpl" class="gc2-icon-tile">
          <span class="gc2-icon-emoji">{{ game.icon }}</span>
        </div>
        <ng-template #gcImgTpl>
          <img loading="lazy" [src]="game.image" [alt]="game.name" class="gc2-logo" />
        </ng-template>

        <!-- Dynamic frosted play overlay on hover -->
        <div class="gc2-hover-overlay">
          <span class="gc2-hover-circle">
            <i class="fas fa-play"></i>
          </span>
        </div>
      </div>

      <!-- Game Name & Play Button Wrapper -->
      <div class="gc2-footer">
        <div class="gc2-name" [title]="game.name">{{ game.name }}</div>
        <button *ngIf="game.maintenance" type="button" class="gc2-btn gc2-btn-maint" disabled (click)="$event.stopPropagation()">
          <i class="fas fa-wrench text-[9px] mr-1"></i> Maintenance
        </button>
        <button *ngIf="!game.maintenance" (click)="playGame(game); $event.stopPropagation()" class="gc2-btn">
          <i class="fas fa-play text-[9px] mr-1"></i> Play Now
        </button>
      </div>
    </div>
</ng-template>


<div *ngIf="AddPlayerModal"
  class="fixed inset-0 wallet-modal-backdrop flex items-center justify-center modal-overlay Add_Bal z-[999] px-3 sm:px-4"
  (click)="CloseAddPlayer()">
  <div class="wallet-modal-shell w-full max-w-md" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex items-start justify-between gap-4 mb-5">
      <div class="flex items-center gap-3">
        <!-- Player icon -->
        <div class="wallet-illustration">
          <svg viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="pGrad" x1="0" y1="0" x2="140" y2="140" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stop-color="#E7C98B" />
                <stop offset="50%" stop-color="#F2A56F" />
                <stop offset="100%" stop-color="#D946EF" />
              </linearGradient>
            </defs>
            <ellipse cx="70" cy="75" rx="56" ry="50" fill="url(#pGrad)" opacity="0.2" filter="blur(12px)" />
            <circle cx="70" cy="58" r="28" fill="#1E1B4B" stroke="url(#pGrad)" stroke-width="2.5" />
            <circle cx="70" cy="54" r="18" fill="#2D24A5" />
            <path
              d="M70 32C60.06 32 52 40.06 52 50C52 59.94 60.06 68 70 68C79.94 68 88 59.94 88 50C88 40.06 79.94 32 70 32Z"
              fill="#4338CA" />
            <path
              d="M70 40C64.48 40 60 44.48 60 50C60 55.52 64.48 60 70 60C75.52 60 80 55.52 80 50C80 44.48 75.52 40 70 40Z"
              fill="#0EA5E9" />
            <path d="M28 118C28 90.39 46.39 72 70 72C93.61 72 112 90.39 112 118" stroke="url(#pGrad)" stroke-width="3"
              stroke-linecap="round" fill="none" />
            <path d="M35 118C35 95.36 50.67 80 70 80C89.33 80 105 95.36 105 118" fill="#1E1B4B" stroke="url(#pGrad)"
              stroke-width="2" />
          </svg>
        </div>

        <div>
          <h2 class="wallet-modal-title">Add Player</h2>
          <p class="wallet-modal-subtitle">
            Join the action and start playing now!
          </p>
        </div>
      </div>

      <button (click)="CloseAddPlayer()" class="wallet-modal-close">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <!-- Game info card -->
    <div class="wallet-game-card mb-5">
      <img loading="lazy" [src]="gameimage" alt="game" onerror="this.src='/table-felt-placeholder.png'" />
      <div class="text-left">
        <p class="game-label">Selected Game</p>
        <h3 class="game-name">{{ gamename }}</h3>
      </div>
    </div>

    <p class="text-sm text-[var(--modal-text-muted)] text-center mb-5 px-2">
      Ready to join the action? Be the next player in
      <span class="text-[var(--modal-text-purple)] font-semibold">{{ gamename }}</span>!
    </p>

    <!-- Buttons -->
    <form [formGroup]="scoreForm" class="flex flex-col gap-4">
      <div class="flex flex-col sm:flex-row gap-3 w-full">
        <button type="button" class="wallet-btn-cancel" (click)="CloseAddPlayer()">
          Cancel
        </button>
        <button type="submit" class="wallet-btn-action" (click)="onPlayerSubmit()">
          <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 5v14M5 12h14" />
          </svg>
          Add Player
        </button>
      </div>
    </form>
  </div>
</div>

<!-- Instant games cards -->

<div class="flex justify-between mx-auto items-center px-0 lg:px-4 mb-2" *ngIf="isToken && isDashboardPage">
  <div class="tab-head">Instant Games</div>
  <div class="search-wrap">
    <input type="text" class="search-input" placeholder="Search instant games..." [(ngModel)]="instantSearchTerm"
      (input)="onInstantSearch()" />
    <button class="search-btn" aria-label="Search">
      <svg viewBox="0 0 20 20" fill="currentColor" width="14" height="14">
        <path fill-rule="evenodd"
          d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
          clip-rule="evenodd" />
      </svg>
    </button>
  </div>
</div>

<div id="quick-scrolling-id" *ngIf="isToken && isDashboardPage"
  class="games-grid-container text-center"
  [ngClass]="!isToken ? 'mx-0 2xl:mx-28' : ''">
  <ng-container *ngFor="let game of filteredQuickGames; trackBy: trackByGameName">
    <div class="game-card-v2 group" (click)="!game.maintenance && redirectTo(game.redirectLink)">

      <!-- Status badges -->
      <span *ngIf="game?.isHot" class="gc2-badge gc2-badge-hot">
        <i class="fas fa-fire mr-1 text-[8px]"></i>
        <span class="gc2-badge-text">HOT</span>
      </span>

      <span *ngIf="game?.isNew && !game?.isHot" class="gc2-badge gc2-badge-new">
        <i class="fas fa-bolt mr-1 text-[8px]"></i>
        <span class="gc2-badge-text">NEW</span>
      </span>

      <!-- Bonus corner badge -->
      <span *ngIf="game?.bonus" class="gc2-badge-bonus">
        <span class="gc2-bonus-percent">+{{ game?.bonus }}%</span>
        <span class="gc2-bonus-label">BONUS</span>
      </span>

      <!-- TOP (image area) with hover play overlay -->
      <div class="gc2-artwork">
        <div *ngIf="game.icon; else gcImgA" class="gc2-icon-tile">
          <span class="gc2-icon-emoji">{{ game.icon }}</span>
        </div>
        <ng-template #gcImgA>
          <img loading="lazy" [src]="game.image" [alt]="game.name" class="gc2-logo" />
        </ng-template>

        <!-- Dynamic frosted play overlay on hover -->
        <div class="gc2-hover-overlay">
          <span class="gc2-hover-circle">
            <i class="fas fa-play"></i>
          </span>
        </div>
      </div>

      <!-- Game Name & Play Button Wrapper -->
      <div class="gc2-footer">
        <div class="gc2-name" [title]="game.name">{{ game.name }}</div>
        <button *ngIf="game.maintenance" type="button" class="gc2-btn gc2-btn-maint" disabled (click)="$event.stopPropagation()">
          <i class="fas fa-wrench text-[9px] mr-1"></i> Maintenance
        </button>
        <button *ngIf="!game.maintenance" (click)="redirectTo(game.redirectLink); $event.stopPropagation()" class="gc2-btn">
          <i class="fas fa-play text-[9px] mr-1"></i> Play Now
        </button>
      </div>
    </div>
  </ng-container>
</div>

<!-- HOT GAMES -->
<div *ngIf="isToken && isDashboardPage && !gamesLoading && hotGames.length" id="hot-games-section"
  class="scroll-mt-24 mt-4">
  <div class="flex justify-between mx-auto px-0 items-center lg:px-4 mb-2">
    <div class="tab-head">Hot Games 🔥</div>
  </div>
  <div
    class="games-grid-container text-center">
    <ng-container *ngFor="let game of hotGames; trackBy: trackByGameName">
      <ng-container *ngTemplateOutlet="gameCardTpl; context: { $implicit: game }"></ng-container>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="!isDashboardPage">
  <!-- LANDING GAME GRID -->
  <div
    class="games-grid-container text-center">
    <ng-container *ngFor="let game of displayedGames; trackBy: trackByGameName">
      <div class="game-card-v2 group" (click)="OnPlayNow(game)">
        <!-- Status badges -->
        <span *ngIf="game?.isHot" class="gc2-badge gc2-badge-hot">
          <i class="fas fa-fire mr-1 text-[8px]"></i>
          <span class="gc2-badge-text">HOT</span>
        </span>

        <span *ngIf="game?.isNew && !game?.isHot" class="gc2-badge gc2-badge-new">
          <i class="fas fa-bolt mr-1 text-[8px]"></i>
          <span class="gc2-badge-text">NEW</span>
        </span>

        <!-- Bonus corner badge -->
        <span *ngIf="game?.bonus" class="gc2-badge-bonus">
          <span class="gc2-bonus-percent">+{{ game?.bonus }}%</span>
          <span class="gc2-bonus-label">BONUS</span>
        </span>

        <!-- Top artwork area with hover play overlay -->
        <div class="gc2-artwork">
          <div *ngIf="game.icon; else gcImgB" class="gc2-icon-tile">
            <span class="gc2-icon-emoji">{{ game.icon }}</span>
          </div>
          <ng-template #gcImgB>
            <img loading="lazy" [src]="game.image" [alt]="game.name" class="gc2-logo" />
          </ng-template>

          <div class="gc2-hover-overlay">
            <span class="gc2-hover-circle">
              <i class="fas fa-play"></i>
            </span>
          </div>
        </div>

        <!-- Game Name & Play Button Wrapper -->
        <div class="gc2-footer">
          <div class="gc2-name" [title]="game.name">{{ game.name }}</div>
          <button (click)="OnPlayNow(game); $event.stopPropagation()" class="gc2-btn">
            <i class="fas fa-play text-[9px] mr-1"></i> Play Now
          </button>
        </div>
      </div>
    </ng-container>
  </div>

  <div *ngIf="hasMoreGames" class="flex justify-center mt-6 mb-8">
    <button (click)="toggleShowAll()" class="gc2-more-btn">
      <i class="fas fa-gamepad mr-2 text-[#E8A2AD]"></i>
      <span>{{ showAllGames ? "View Less" : "View All Games" }}</span>
      <i class="fas ml-2 text-xs" [ngClass]="showAllGames ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </button>
  </div>

  <!-- QUICK GAMES (landing) -->
  <div class="px-2 sm:px-4 lg:px-4 mt-12">
    <div
      class="flex flex-col md:flex-row items-center justify-between gap-6 mb-8 border-b border-white/10 pb-4">
      <div>
        <div class="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#800020]/25 text-[#F7E7CE] border border-[#D47A88]/30 text-xs font-bold tracking-wider uppercase mb-2 shadow-sm">
          <i class="fas fa-bolt text-[#F7E7CE]"></i>
          Quick Games
        </div>
        <h2 class="text-white font-extrabold text-2xl sm:text-3xl tracking-tight">
          Instant Play, <span class="text-transparent bg-clip-text bg-gradient-to-r from-[#F7E7CE] via-[#E8A2AD] to-[#D47A88] font-bold">Instant Wins</span>
        </h2>
      </div>
    </div>
  </div>

  <div
    class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3 sm:gap-4 md:gap-4 lg:gap-4.5 mx-auto text-center px-2 sm:px-4 lg:px-4 py-2 pb-4">
    <ng-container *ngFor="let game of filteredQuickGames; trackBy: trackByGameName">
      <div class="game-card-v2 group" (click)="quickPlay(game)">
        <span *ngIf="game?.isHot" class="gc2-badge gc2-badge-hot">
          <i class="fas fa-fire mr-1 text-[8px]"></i>
          <span class="gc2-badge-text">HOT</span>
        </span>
        <span *ngIf="game?.bonus" class="gc2-badge-bonus">
          <span class="gc2-bonus-percent">+{{ game?.bonus }}%</span>
          <span class="gc2-bonus-label">BONUS</span>
        </span>

        <!-- Top artwork area with hover play overlay -->
        <div class="gc2-artwork">
          <div *ngIf="game.icon; else gcImgC" class="gc2-icon-tile">
            <span class="gc2-icon-emoji">{{ game.icon }}</span>
          </div>
          <ng-template #gcImgC>
            <img loading="lazy" [src]="game.image" [alt]="game.name" class="gc2-logo" />
          </ng-template>

          <div class="gc2-hover-overlay">
            <span class="gc2-hover-circle">
              <i class="fas fa-play"></i>
            </span>
          </div>
        </div>

        <!-- Game Name & Play Button Wrapper -->
        <div class="gc2-footer">
          <div class="gc2-name" [title]="game.name">{{ game.name }}</div>
          <button *ngIf="game.maintenance" type="button" class="gc2-btn gc2-btn-maint" disabled (click)="$event.stopPropagation()">
            <i class="fas fa-wrench text-[9px] mr-1"></i> Maintenance
          </button>
          <button *ngIf="!game.maintenance" (click)="quickPlay(game); $event.stopPropagation()" class="gc2-btn">
            <i class="fas fa-play text-[9px] mr-1"></i> Play Now
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>

<div class="w-full px-0 lg:px-4" *ngIf="isToken && isDashboardPage">
  <div class="flex justify-between mx-auto">
    <div class="tab-head">Spinner</div>
  </div>
  <app-spinner id="spin-scrolling-id" *ngIf="!isLandingPage" [showHeaderSection]="false"></app-spinner>
</div>

<div class="flex justify-between mx-auto px-0 lg:px-4" *ngIf="isToken && isDashboardPage">
  <div class="tab-head">Scratch Card</div>
</div>

<app-sectrech-card-list id="scratchScrollSection" [isDashBoard]="true" [isHomePage]="router.url == '/' ? true : false">
</app-sectrech-card-list>

<button (click)="toggleShowAllScratch()" *ngIf="isDashboardPage" class="scratch-show-all-btn">
  Show All
</button>
